export interface Messages {
  // Common
  loading: string
  save: string
  cancel: string
  delete: string
  confirm: string
  close: string
  error: string
  success: string
  warning: string
  info: string

  // Actions
  activate: string
  deactivate: string
  create: string
  edit: string
  update: string
  refresh: string
  search: string
  filter: string
  clear: string

  // Product management
  product: string
  products: string
  productName: string
  productPrice: string
  productCategory: string
  productStatus: string
  productErrors: string
  productActions: string

  // Bulk operations
  bulkOperations: string
  bulkActivate: string
  bulkDeactivate: string
  bulkDelete: string
  bulkSuccess: string
  bulkError: string

  // Status
  statusActive: string
  statusInactive: string
  statusCompleted: string
  statusValidationFailed: string
  statusProcessing: string
  statusPending: string

  // Categories
  category: string
  categories: string
  categoryNone: string
  categoryMapping: string

  // Empty states
  emptyProductsList: string
  emptyCategories: string

  // Notifications
  itemsActivated: string
  itemsDeactivated: string
  itemsDeleted: string
  itemDeleted: string
  itemStatusChanged: string

  // Confirmations
  confirmDelete: string
  confirmDeleteMultiple: string
  deleteWithProducts: string
  deleteWarning: string

  // Errors
  loadError: string
  saveError: string
  deleteError: string
  activateError: string
  deactivateError: string

  // Filters
  filterStatus: string
  filterCategory: string
  filterHasProduct: string
  filterWithProduct: string
  filterWithoutProduct: string

  // Placeholders
  searchPlaceholder: string

  // Stats
  totalItems: string
  selectedItems: string
}

export const russianMessages: Messages = {
  // Common
  loading: 'Загрузка...',
  save: 'Сохранить',
  cancel: 'Отмена',
  delete: 'Удалить',
  confirm: 'Подтвердить',
  close: 'Закрыть',
  error: 'Ошибка',
  success: 'Успешно',
  warning: 'Предупреждение',
  info: 'Информация',

  // Actions
  activate: 'Активировать',
  deactivate: 'Деактивировать',
  create: 'Создать',
  edit: 'Редактировать',
  update: 'Обновить',
  refresh: 'Обновить',
  search: 'Поиск',
  filter: 'Фильтр',
  clear: 'Очистить',

  // Product management
  product: 'Товар',
  products: 'Товары',
  productName: 'Название товара',
  productPrice: 'Цена',
  productCategory: 'Категория',
  productStatus: 'Статус',
  productErrors: 'Ошибки',
  productActions: 'Действия',

  // Bulk operations
  bulkOperations: 'Массовые операции',
  bulkActivate: 'Активировать',
  bulkDeactivate: 'Деактивировать',
  bulkDelete: 'Удалить',
  bulkSuccess: 'Операция выполнена успешно',
  bulkError: 'Ошибка при выполнении операции',

  // Status
  statusActive: 'Активен',
  statusInactive: 'Неактивен',
  statusCompleted: 'Завершено',
  statusValidationFailed: 'Ошибка валидации',
  statusProcessing: 'Обработка',
  statusPending: 'Ожидание',

  // Categories
  category: 'Категория',
  categories: 'Категории',
  categoryNone: 'Без категории',
  categoryMapping: 'Сопоставление категорий',

  // Empty states
  emptyProductsList: 'Товары не найдены',
  emptyCategories: 'Категории не найдены',

  // Notifications
  itemsActivated: 'Активировано товаров',
  itemsDeactivated: 'Деактивировано товаров',
  itemsDeleted: 'Удалено элементов',
  itemDeleted: 'Элемент удален',
  itemStatusChanged: 'Статус товара изменен',

  // Confirmations
  confirmDelete: 'Вы действительно хотите удалить этот элемент?',
  confirmDeleteMultiple: 'Вы действительно хотите удалить {count} элементов?',
  deleteWithProducts: 'Также удалить связанные товары из каталога',
  deleteWarning:
    'Внимание! Товары будут полностью удалены из каталога и не смогут быть восстановлены.',

  // Errors
  loadError: 'Ошибка при загрузке',
  saveError: 'Ошибка при сохранении',
  deleteError: 'Ошибка при удалении',
  activateError: 'Ошибка при активации',
  deactivateError: 'Ошибка при деактивации',

  // Filters
  filterStatus: 'Статус',
  filterCategory: 'Категория',
  filterHasProduct: 'Наличие товара',
  filterWithProduct: 'С товаром',
  filterWithoutProduct: 'Без товара',

  // Placeholders
  searchPlaceholder: 'Название, артикул, описание...',

  // Stats
  totalItems: 'Всего товаров',
  selectedItems: 'Выбрано',
}

// Simple i18n function
export const t = (key: keyof Messages, params?: Record<string, unknown>): string => {
  let message = russianMessages[key] || key

  if (params) {
    Object.entries(params).forEach(([paramKey, paramValue]) => {
      message = message.replace(`{${paramKey}}`, String(paramValue))
    })
  }

  return message
}

// Create a composable for i18n
export const useI18n = () => {
  return {
    t,
    messages: russianMessages,
  }
}
